import { render, staticRenderFns } from "./u-swiper-pagination-line.vue?vue&type=template&id=2d4e5e96&scoped=true&"
import script from "./u-swiper-pagination-line.vue?vue&type=script&lang=js&"
export * from "./u-swiper-pagination-line.vue?vue&type=script&lang=js&"
import style0 from "./u-swiper-pagination-line.vue?vue&type=style&index=0&id=2d4e5e96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e5e96",
  null
  
)

export default component.exports